import React from 'react';
import MangaList from './MangaList';  // Import MangaList component
import useMangaFetch from './MangaFetchHook';  // Import the custom hook for fetching manga data
import SEOHead from '../SEO/SEOHead';

const MangaHomePage = () => {
  const { mangaItems, isLoading } = useMangaFetch();  // Use the hook to fetch manga data

  return (
    <div className="MangaHomePage">
      <SEOHead
        title="ChibiDash | Manga Hub - Read & Explore Manga"
        description="Explore manga on ChibiDash. Browse popular manga series, read chapters, and discover new titles."
        path="/manga-home"
      />
      <h1>Welcome to Manga Home</h1>
      <p>Explore your favorite mangas here!</p>

      {isLoading ? (
        <p>Loading...</p>  // Show loading text while data is being fetched
      ) : (
        <MangaList mangaItems={mangaItems} />  // Render MangaList with fetched manga items
      )}
    </div>
  );
};

export default MangaHomePage;
